<template>
  <div class="docvue-background">
    <img src="/img/landing-page.jpg" style="width: 100%" />
    <div>
      <v-row class="pt-4 pb-4 login-banner" align="center" justify="center">
        <v-btn size="x-large" data-cy="login-button" color="secondary" @click="login">Login</v-btn>
        <v-btn size="x-large" color="primary" class="ml-4" @click="signup">Sign up</v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {};
  },
  props: ["redirectTo"],
  methods: {
    async login() {
      await this.persistSelectedCompanyId(this.redirectTo);
      this.$auth0.loginWithRedirect({ appState: { target: this.redirectTo || "/" } });
    },
    signup() {
      this.$router.push({ path: "/register" });
    },
    async persistSelectedCompanyId(redirectUrl) {
      if (!redirectUrl) return;
      try {
        const url = new URL(redirectUrl, window.location.origin);
        const selectedCompanyId = url.searchParams.get("selectedCompanyId");
        if (selectedCompanyId) {
          const parsedId = Number(selectedCompanyId);
          if (!Number.isNaN(parsedId)) {
            await this.$store.dispatch("auth0Store/updateCompanyId", { selectedCompanyId: parsedId });
          }
        }
      } catch (e) {
        // ignore invalid URLs
      }
    },
    async init() {
      let redirectTo = this.$route.query.redirectTo;
      if (Array.isArray(redirectTo)) redirectTo = redirectTo[0];
      if (!redirectTo) return;

      // Auto-login only when redirected from Cloud with a selectedCompanyId
      try {
        const url = new URL(redirectTo, window.location.origin);
        if (url.searchParams.has("selectedCompanyId")) {
          await this.persistSelectedCompanyId(redirectTo);
          this.$auth0.loginWithRedirect({ appState: { target: redirectTo } });
        }
      } catch (e) {
        // ignore invalid URLs
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped></style>
